import React from "react";
import "./styles.css";
import logo from "./cover-logo.jpg";

const FooterRotationLogoText = (props) => {
  return (
    <div className="footer-logo-box">
      <div className="rotation-box">
        <svg
          className="rounded-text"
          style={{
            letterSpacing: props.letterSpacing + "px",
            fontSize: props.fontSize + "px",
          }}
          viewBox="0 0 200 200"
        >
          <path
            id="textPath"
            d="M 85,0 A 85,85 0 0 1 -85,0 A 85,85 0 0 1 85,0"
            transform="translate(100,100)"
            fill="none"
            strokeWidth="0"
          ></path>
          <g>
            <text text-anchor="start">
              <textPath class="coloring" href="#textPath" startOffset="0%">
                {props.text}
              </textPath>
            </text>
          </g>
        </svg>

        <img
          className="no-rotation-image"
          height="167px"
          width="167px"
          src={logo}
          alt="footer img rotation"
        />
      </div>
    </div>
  );
};

export default FooterRotationLogoText;
